import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import ConnectedHeader from '../connectedComponents/ConnectedHeader.js';
import 'moment/locale/zh-cn';
import ConnectedMenu from '../connectedComponents/ConnectedMenu.js';
import { changeListWidth } from '../utils/index.js';
import ConnectedReportCT from './ConnectedReportCT.js';
class ReportList extends Component {
  static propTypes = {
    form: PropTypes.object,
    server: PropTypes.object,
    history: PropTypes.object,
    setCurrentSearchInfoData: PropTypes.func,
    setApplicationData: PropTypes.func,
    user: PropTypes.object,
    current: PropTypes.object,
  };

  static defaultProps = {
    user: {},
    current: {},
  };
  constructor(props) {
    super(props);

    this.state = {};
  }

  applyToCertId = state => {
    this.setState({ certIdShow: state });
  };
  render() {
    return (
      <div className="form-bg" id="reportList">
        <ConnectedMenu toggleCollapsed={() => changeListWidth(this)} />
        <div className="theme-content">
          <ConnectedHeader
            toggleCollapsed={() => changeListWidth(this)}
            certIdShow={this.state.certIdShow}
            applyToCertId={this.applyToCertId}
          />
          <div className="box report-box">
            <ConnectedReportCT
              {...this.props}
              applyToCertId={this.applyToCertId}
            />
          </div>
        </div>
      </div>
    );
  }
}

export default withRouter(ReportList);
